import styled from 'styled-components';
// we do need to increase the click area for the icons on mobile to avoid miss clicks that is why this wrapper was added
// on desktop we do not need to add click areas
const IconWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 24px;
  height: 24px;
  @media screen and (min-width: 375px) {
    width: 30px;
    height: 30px;
  }
  @media screen and (min-width: 440px) {
    width: 33px;
    height: 33px;
  }
  &:hover {
    background-color: #d4d4d55e;
    border-radius: 50%;
  }
`;

export default IconWrapper;
